// extracted by mini-css-extract-plugin
module.exports = {"notification":"notification_1Lpmfs","error":"error_1mNNRS notification_1Lpmfs","success":"success_1TocGf notification_1Lpmfs","info":"info_3O8723 notification_1Lpmfs"};